module.exports = __webpack_public_path__ + "assets/img/teacher.a16557b2.png";